import React, { useState, useEffect } from 'react';
import './_CookieConsent.scss';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [preferences, setPreferences] = useState({
    necessary: true, // Always enabled as they are required
    analytics: false,
    marketing: false,
  });

  useEffect(() => {
    const cookiesAccepted = document.cookie.includes('cookiesAccepted=true');
    if (!cookiesAccepted) setShowBanner(true);
  }, []);

  const savePreferences = () => {
    // Save cookie preferences
    document.cookie = `necessary=${preferences.necessary}; path=/; max-age=2592000`; // 30 days
    document.cookie = `analytics=${preferences.analytics}; path=/; max-age=2592000`;
    document.cookie = `marketing=${preferences.marketing}; path=/; max-age=2592000`;
    document.cookie = `cookiesAccepted=true; path=/; max-age=2592000`;
    setShowBanner(false);
  };

  const handleToggle = (category) => {
    setPreferences({ ...preferences, [category]: !preferences[category] });
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-consent">
      <p>
        We use cookies to improve your experience. Choose your preferences or view our{' '}
        <a href="/privacy">Privacy Policy</a>.
      </p>
      <div className="preferences">
        <label>
          <input
            type="checkbox"
            checked={preferences.analytics}
            onChange={() => handleToggle('analytics')}
          />
          Allow Analytics Cookies
        </label>
        <label>
          <input
            type="checkbox"
            checked={preferences.marketing}
            onChange={() => handleToggle('marketing')}
          />
          Allow Marketing Cookies
        </label>
      </div>
      <div className="actions">
        <button onClick={savePreferences}>Save Preferences</button>
      </div>
    </div>
  );
};

export default CookieConsent;



